// DS: i6.13
import React from 'react';
import IconWrap, { Props } from '../IconWrap';

const TheaterView: React.FC<Props> = props => {
  return (
    <IconWrap {...props}>
      <svg
        width="0"
        height="0"
        viewBox="0 0 24 24"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path d="M20 16H4V9h16v7zm1-9H3a1 1 0 00-1 1v9a1 1 0 001 1h18a1 1 0 001-1V8a1 1 0 00-1-1z" />
      </svg>
    </IconWrap>
  );
};
TheaterView.displayName = 'TheaterView';

export default TheaterView;
